module.exports = __webpack_public_path__ + "img/dialog-option-img2.4c44bd0e.png";